import useThemeStore from '@/store/useThemeStore';

// 使用 getter 函数动态获取当前主题的颜色
export const colors = {
  get mainBgColor() { return useThemeStore.getState().colors.mainBgColor; },
  get loadingColor() { return useThemeStore.getState().colors.loadingColor; },
  get themeColor() { return useThemeStore.getState().colors.themeColor; },
  get themeColorDark() { return useThemeStore.getState().colors.themeColorDark; },
  get themeColorLight() { return useThemeStore.getState().colors.themeColorLight; },
  get secondaryColor() { return useThemeStore.getState().colors.secondaryColor; },
  get thirdColor() { return useThemeStore.getState().colors.thirdColor; },
  get mainTextColor() { return useThemeStore.getState().colors.mainTextColor; },
  get mainTitleColor() { return useThemeStore.getState().colors.mainTitleColor; },
  get progressBarColor() { return useThemeStore.getState().colors.progressBarColor; },
  get homeBgColor() { return useThemeStore.getState().colors.homeBgColor; },
  get homeTextBlackColor() { return useThemeStore.getState().colors.homeTextBlackColor; },
  get buttonGreenColor() { return useThemeStore.getState().colors.buttonGreenColor; },
  get buttonPurpleColor() { return useThemeStore.getState().colors.buttonPurpleColor; },
  get buttonRedColor() { return useThemeStore.getState().colors.buttonRedColor; },
  get buttonBlueColor() { return useThemeStore.getState().colors.buttonBlueColor; },
  get buttonOrangeColor() { return useThemeStore.getState().colors.buttonOrangeColor; },
  get buttonVibrantColor() { return useThemeStore.getState().colors.buttonVibrantColor; },
  get buttonCyanColor() { return useThemeStore.getState().colors.buttonCyanColor; },
  get buttonGrayColor() { return useThemeStore.getState().colors.buttonGrayColor; },
  get calendarLearnedColor() { return useThemeStore.getState().colors.calendarLearnedColor; },
  get correctAnswerColor() { return useThemeStore.getState().colors.correctAnswerColor; },
  get correctAnswerColorLight() { return useThemeStore.getState().colors.correctAnswerColorLight; },
  get wrongAnswerColor() { return useThemeStore.getState().colors.wrongAnswerColor; },
  get wrongAnswerColorLight() { return useThemeStore.getState().colors.wrongAnswerColorLight; },
  get homeTitleColor() { return useThemeStore.getState().colors.homeTitleColor; },
  get dashboardMainColor() { return useThemeStore.getState().colors.dashboardMainColor; },
  get extracurricularMainColor() { return useThemeStore.getState().colors.extracurricularMainColor; },
  get gameCenterMainColor() { return useThemeStore.getState().colors.gameCenterMainColor; },
  get panelTitleColor() { return useThemeStore.getState().colors.panelTitleColor; },
  get panelBgColor() { return useThemeStore.getState().colors.panelBgColor; },
  get streakColor() { return useThemeStore.getState().colors.streakColor; },
  get streakOutlineColor() { return useThemeStore.getState().colors.streakOutlineColor; },
}
